import { API } from 'service/API'

import { ContactsService } from './Contacts/ContactsService'
import { BillingEntitiesService } from './LegalEntities/BillingEntityService'
import { LegalEntitiesService } from './LegalEntities/LegalEntityService'
import { LocationsService } from './Locations/LocationsService'
import { TNetworkEntityJSON, TNetworkEntityResJSON } from './NetworkEntity'
import { OrganizationsService } from './Organizations/OrganizationsService'

export interface INetworkServiceInterface {
  get: (_id: string) => Promise<TNetworkEntityJSON>
  getAll: () => Promise<TNetworkEntityResJSON>
  findByIds: (_ids: string[]) => Promise<TNetworkEntityJSON[]>
  search: (searchText: string, organizationId?: string) => Promise<TNetworkEntityResJSON>
  add?: (name: string) => Promise<void>
  save: (entity: Partial<TNetworkEntityJSON>) => Promise<TNetworkEntityJSON>
  delete: (entityId: string) => Promise<void>
}

export class NetworkService {
  contactsService: ContactsService
  locationsService: LocationsService
  organizationsService: OrganizationsService
  legalEntitiesService: LegalEntitiesService
  billingEntitiesService: BillingEntitiesService

  constructor(api: API) {
    this.contactsService = new ContactsService(api)
    this.locationsService = new LocationsService(api)
    this.organizationsService = new OrganizationsService(api)
    this.legalEntitiesService = new LegalEntitiesService(api)
    this.billingEntitiesService = new BillingEntitiesService(api)
  }
}
